/* ─────────────────────────────────────────────────────────
   Demand Vintage — Wishlist + Recently Viewed
   ───────────────────────────────────────────────────────── */

const DV_WL_KEY     = 'dv_wishlist';
const DV_RV_KEY     = 'dv_recent';
const DV_RV_MAX     = 4;

/* ── localStorage helpers ─────────────────────────────── */
function dvGet(key) {
  try { return JSON.parse(localStorage.getItem(key)) || []; } catch(_) { return []; }
}
function dvSet(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch(_) {}
}

/* ── Wishlist core ────────────────────────────────────── */
function wlAll()       { return dvGet(DV_WL_KEY); }
function wlHas(handle) { return wlAll().some(p => p.handle === handle); }

function wlToggle(btn) {
  const { handle, title, price, image, url } = btn.dataset;
  let list = wlAll();
  const idx = list.findIndex(p => p.handle === handle);
  if (idx >= 0) {
    list.splice(idx, 1);
  } else {
    list.unshift({ handle, title, price: parseInt(price, 10) || 0, image, url });
  }
  dvSet(DV_WL_KEY, list);
  syncAllHearts();
  updateWishlistCount();
}

function syncAllHearts() {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const saved = wlHas(btn.dataset.handle);
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  });
}

function updateWishlistCount() {
  const count = wlAll().length;
  document.querySelectorAll('.wishlist-count').forEach(el => {
    el.textContent = count;
    el.hidden = count === 0;
  });
}

/* ── Wishlist page ────────────────────────────────────── */
function renderWishlistPage() {
  const grid  = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');
  if (!grid) return;

  const items = wlAll();
  if (items.length === 0) {
    grid.innerHTML = '';
    if (empty) empty.hidden = false;
    return;
  }
  if (empty) empty.hidden = true;

  grid.innerHTML = items.map(p => {
    const price = p.price ? '£' + (p.price / 100).toFixed(2).replace(/\.00$/, '') : '';
    const img   = p.image
      ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">`
      : `<div class="product-card__img-placeholder"></div>`;
    return `<div class="product-card-wrap">
      <a href="${p.url}" class="product-card">
        <div class="product-card__media" style="aspect-ratio:3/4;overflow:hidden;">${img}</div>
        <p class="product-card__title">${escapeHtml(p.title)}</p>
        <p class="product-card__price">${price}</p>
      </a>
      <button class="wishlist-btn is-saved"
        data-handle="${p.handle}" data-title="${escapeHtml(p.title)}"
        data-price="${p.price}" data-image="${p.image}" data-url="${p.url}"
        aria-label="Remove from wishlist" aria-pressed="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
      </button>
    </div>`;
  }).join('');

  grid.querySelectorAll('.wishlist-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      wlToggle(this);
      renderWishlistPage();
    });
  });
}

/* ── Recently Viewed ──────────────────────────────────── */
function rvTrack(data) {
  if (!data || !data.handle) return;
  let list = dvGet(DV_RV_KEY).filter(p => p.handle !== data.handle);
  list.unshift(data);
  dvSet(DV_RV_KEY, list.slice(0, DV_RV_MAX));
}

function renderRecentlyViewed() {
  const section = document.getElementById('recently-viewed-section');
  const track   = document.getElementById('recently-viewed-track');
  if (!section || !track) return;

  const current = section.dataset.currentHandle;
  const items   = dvGet(DV_RV_KEY).filter(p => p.handle !== current).slice(0, 4);
  if (items.length === 0) return;

  section.hidden = false;
  track.innerHTML = items.map(p => {
    const price = p.price ? '£' + (p.price / 100).toFixed(2).replace(/\.00$/, '') : '';
    const img   = p.image
      ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">`
      : '';
    return `<div class="product-card-wrap">
      <a href="${p.url}" class="product-card">
        <div class="product-card__media">${img}</div>
        <p class="product-card__title">${escapeHtml(p.title)}</p>
        <p class="product-card__price">${price}</p>
      </a>
    </div>`;
  }).join('');
}

/* ── Utility ──────────────────────────────────────────── */
function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/* ── Init ─────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  // Bind wishlist toggle buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-btn');
    if (btn) { e.preventDefault(); wlToggle(btn); }
  });

  syncAllHearts();
  updateWishlistCount();

  // Track current product page
  if (window.__dvProduct) {
    rvTrack(window.__dvProduct);
  }

  renderRecentlyViewed();
  renderWishlistPage();
});
